<template>
    <div>
        <div
            class="b-table-sticky-header table-responsive max-height-70"
        >
            <b-table-simple
                v-if="noData"
                no-border-collapse
            >
                <b-thead>
                    <b-tr>
                        <b-th style="width:70%;">
                            Type
                        </b-th>
                        <b-th class="text-right">
                            Cost
                        </b-th>
                        <b-th class="text-right">
                            Qty.
                        </b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr>
                        <b-td :colspan="3" class="pb-50 pt-2 text-center">
                            <SVGEmptyIcon/>
                            <div>

                                {{ $t("org.message.No Data") }}
                            </div>
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
            <b-table-simple
                v-else
                no-border-collapse
                :items="data"
            >
                <b-thead>
                    <b-tr>
                        <b-th style="width:70%;">
                            Type
                        </b-th>
                        <b-th class="text-right">
                            Cost
                        </b-th>
                        <b-th class="text-right">
                            Qty.
                        </b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <template v-for="(item, index) in data">
                        <b-tr :key="`main-${index}`">
                            <b-td style="width:70%;">
                                <b-form-checkbox
                                    v-model="checkboxModels[item.resourceId]"
                                    @change="getToggleDetails(item, index)"
                                >
                                    {{ item.resourceId }}
                                </b-form-checkbox>
                            </b-td>
                            <b-td class="text-right">
                                <span
                                    :class="{'font-weight-bolder': item.showChildren }"
                                >
                                    {{ $_getDollar(item.cost) }}
                                </span>
                            </b-td>
                            <b-td class="text-right">
                                <span
                                    :class="{'font-weight-bolder': item.showChildren }"
                                >
                                    {{ $_getAmount(item.usageAmount, 'DataTransfer') }}
                                </span>
                            </b-td>
                        </b-tr>
                        <b-tr
                            v-if="item.showChildren"
                            :key="`sub-${index}`"
                        >
                            <b-td colspan="3">
                                <b-card no-body class="mb-0">
                                    <b-row
                                        class="mb-0" v-for="(subItem, subIndex) in item.children" :key="subIndex"
                                    >
                                        <b-col md="8" class="mb-1">
                                            {{ subItem.usageType }}
                                        </b-col>
                                        <b-col md="2" class="text-right">
                                            {{ $_getDollar(subItem.cost) }}
                                        </b-col>
                                        <b-col md="2" class="text-right">
                                            {{ $_getAmount(subItem.usageAmount, 'DataTransfer') }}
                                        </b-col>
                                    </b-row>
                                </b-card>
                            </b-td>
                        </b-tr>
                    </template>
                </b-tbody>
            </b-table-simple>
        </div>
        <b-pagination
            v-if="!noData"
            v-model="pageObj.currentPage"
            :total-rows="lengthsOfTransferResourceIds"
            :per-page="pageObj.perPage"
            first-text="First"
            prev-text="Prev"
            next-text="Next"
            last-text="Last"
            @change="fetchCurrentPage"
            class="mt-1 mr-1"
            align="right"
        ></b-pagination>
    </div>
</template>

<script>
import { toRefs, getCurrentInstance, computed } from '@vue/composition-api'
import SVGEmptyIcon from '@/assets/images/empty.svg'
export default {
    components: {
        SVGEmptyIcon
    },
    props: {
        checkboxModels: {
            type: Object,
            default: function () {
                return {}
            }
        },
        lengthsOfTransferResourceIds: {
            type: Number,
            default: function () {
                return 0
            }
        },
        data: {
            type: Array,
            default: function () {
                return []
            }
        },
        themeColors: {
            type: Object,
            default: function () {
                return {}
            }
        },
        projectIdx: [String, Number],
        month: String
    },
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const store = vm.$store
        const { projectIdx, month, data } = toRefs(props)
        const fetchCurrentPage = (clickedPage) => store.commit('$_dataTransfers/FETCH_CURRENT_PAGE', { data: clickedPage })
        const noData = computed(() => !data.value.length)
        const pageObj = computed(() => store.getters['$_dataTransfers/pageObj'])
        const getToggleDetails = (item, index) => {
            if (item.showChildren) {
                item.showChildren = !item.showChildren
                return
            }
            context.emit('api:getDataTransfersResourceId', { projectIdx: projectIdx.value, month: month.value, resourceId: item.resourceId, index })
        }
        return {
            noData,
            pageObj,
            fetchCurrentPage,
            getToggleDetails
        }
    }
}
</script>

<style>
</style>
